import React from 'react';
import * as Yup from 'yup';
import { Formik, Field, FieldProps, FormikHelpers } from 'formik';
import { Spin, Input, Button } from 'antd';
import { FormField } from '../../components/FormField';

const validationSchema = Yup.object({
  username: Yup.string()
    .email('Username should be a valid email-address')
    .required('Username is required'),
});

type FormValues = {
  username: string;
};
type Props = {
  onSubmit: (values: FormValues, actions: FormikHelpers<FormValues>) => any;
};

export const ForgotPasswordRequestForm = ({ onSubmit }: Props) => {
  return (
    <Formik onSubmit={onSubmit} initialValues={{ username: '' }} validationSchema={validationSchema}>
      {({ isSubmitting, handleSubmit }) => (
        <div style={{ display: 'flex', flexDirection: 'column', paddingTop: 8 }}>
          <form onSubmit={handleSubmit}>
            <Field name="username">
              {(props: FieldProps) => (
                <FormField {...props}>
                  <Input size="large" placeholder="Username" {...props.field} />
                </FormField>
              )}
            </Field>

            {isSubmitting ? (
              <div style={{ display: 'flex', justifyContent: 'center', padding: '0 0 24px 0' }}>
                <Spin />
              </div>
            ) : (
              <div style={{ padding: 0 }}>
                <Button
                  style={{ width: '100%' }}
                  size="large"
                  type="primary"
                  htmlType="submit"
                  className="login-form-button">
                  Confirm
                </Button>
              </div>
            )}
          </form>
        </div>
      )}
    </Formik>
  );
};
